class ProductCard extends HTMLElement {
  constructor() {
    super();

    const availableSizes = this.querySelector("[data-available-sizes]");
    const availableSizesShowButton = this.querySelector(
      "[data-available-sizes-show]",
    );
    const availableSizesCloseButton = this.querySelector(
      "[data-available-sizes-close]",
    );

    const showModal = (modal) => {
      if (modal.showModal) {
        modal.showModal();
      } else {
        modal.setAttribute("open", "");
      }

      document.body.classList.add("overflow-hidden");
    };

    const closeModal = (modal) => {
      if (modal.close) {
        modal.close();
      } else {
        modal.removeAttribute("open");
      }

      document.body.classList.remove("overflow-hidden");
    };

    availableSizesShowButton?.addEventListener("click", () => {
      showModal(availableSizes);
    });

    availableSizesCloseButton?.addEventListener("click", () => {
      closeModal(availableSizes);
    });

    availableSizes?.addEventListener("click", (event) => {
      if (event.target === availableSizes) {
        closeModal(availableSizes);
      }
    });

    window.addEventListener("keydown", (event) => {
      if (
        event.key === "Escape" &&
        availableSizes.getAttribute("open") === ""
      ) {
        closeModal(availableSizes);
      }
    });
  }
}

customElements.define("product-card", ProductCard);
